var staticStrLast = 'last'

module.exports = staticStrLast



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/staticStrLast.js
// module id = qTg+
// module chunks = 37